/**
 * NoVacancyAvailable (=Keine Verfügbarkeit)
 ProblemsDuringBooking (=Probleme bei der Buchung)
 WrongProductChosen (=Fehlkauf)
 DislikeOfferOrHotel (=Geschenk/Hotel gefällt nicht)
 PersonalReasons (=Persönliche Gründe)
 DuplicateOrder (=Doppelte Bestellung)
 Other (=Anderer Grund)
 */

export default [
    {
        translationKey: 'Cancellation.reasons.noVacancyAvailable',
        value: 'NoVacancyAvailable'
    },
    {
        translationKey: 'Cancellation.reasons.ProblemsDuringBooking',
        value: 'ProblemsDuringBooking'
    },
    {
        translationKey: 'Cancellation.reasons.WrongProductChosen',
        value: 'WrongProductChosen'
    },
    {
        translationKey: 'Cancellation.reasons.DislikeOfferOrHotel',
        value: 'DislikeOfferOrHotel'
    },
    {
        translationKey: 'Cancellation.reasons.PersonalReasons',
        value: 'PersonalReasons'
    },
    {
        translationKey: 'Cancellation.reasons.DuplicateOrder',
        value: 'DuplicateOrder'
    },
    {
        translationKey: 'Cancellation.reasons.Other',
        value: 'Other'
    },
];
